module.exports = __webpack_public_path__ + "img/21_1.14456965.png";